import { GeoJSON } from 'react-leaflet'
import L from 'leaflet';

export default function CustomGeoJSON(props: any) {
  const { geojson = null, socketRef = null, usernameCache = new Map(), onRegisterPendingRequest = null, ...rest } = props;
  if (geojson === null || geojson.features === undefined || geojson.features.length == 0) {
    return (<></>)
  }

  const customMarkerIcon = (type) => {
    if (type == "cutaway_location") {
      return L.icon({
        iconUrl: 'noun-parachute-3098794.svg',
        iconSize: [64, 64], // size of the icon
        iconAnchor: [32, 32], // point of the icon which will correspond to marker's location
        popupAnchor: [32, 32] // point from which the popup should open relative to the iconAnchor
      })
    } else if (type == "prediction_landing") {
      return L.icon({
        iconUrl: 'noun-forest-3098787.svg',
        iconSize: [64, 64], // size of the icon
        iconAnchor: [32, 32], // point of the icon which will correspond to marker's location
        popupAnchor: [32, 32] // point from which the popup should open relative to the iconAnchor
      })
    } else if (type == "prediction_landing_water") {
      return L.icon({
        iconUrl: 'noun-fishing-3098785.svg',
        iconSize: [64, 64], // size of the icon
        iconAnchor: [32, 32], // point of the icon which will correspond to marker's location
        popupAnchor: [32, 32] // point from which the popup should open relative to the iconAnchor
      })
    } else {
      return new L.Icon.Default;
    }
  };

  const setIcon = ({ properties }, latlng) => {
    const type = properties.type;
    const icon = customMarkerIcon(type);

    let marker = L.marker(latlng, { icon: icon });

    let popup_text = "";
    if (type == "cutaway_location") {
      popup_text = `Cutaway <a target='_blank' href=https://maps.google.com/?q=${latlng.lat},${latlng.lng}>location</a>`;
    } else if (type == "prediction_landing" || type == "prediction_landing_water") {
      let model_name = properties.model_name;
      const releaseLink = <a target='_blank' href={`https://maps.google.com/?q=${latlng.lat},${latlng.lng}`}>"location"</a>;
      popup_text = `Predicted landing<br/><a target='_blank' href=https://maps.google.com/?q=${latlng.lat},${latlng.lng}>location</a> with<br/>${model_name}`;
    }
    
    // Build the complete popup text with creator info
    let finalPopupText = popup_text;
    
    // Add creator information to the popup text
    if (properties.userId) {
      // Check cache first
      if (usernameCache.has(properties.userId)) {
        const username = usernameCache.get(properties.userId);
        finalPopupText = popup_text + `<br/><small>Created by: ${username}</small>`;
      } else {
        // We'll fetch it on click
        finalPopupText = popup_text + `<br/><small>Loading creator...</small>`;
      }
    } else if (properties.createdBy) {
      // Fallback to stored username
      finalPopupText = popup_text + `<br/><small>Created by: ${properties.createdBy}</small>`;
    }

    marker.bindPopup(finalPopupText, { offset: [-32, -32] });
    
    // Handle username fetching on click if needed
    const fetchCreatorInfo = () => {
      if (properties.userId && !usernameCache.has(properties.userId) && socketRef?.current && socketRef.current.readyState === WebSocket.OPEN) {
        // Query from server
        const requestId = `${Date.now()}_${Math.random()}`;
        
        // Register the pending request
        if (onRegisterPendingRequest) {
          onRegisterPendingRequest(requestId, { 
            layer: marker, 
            userId: properties.userId,
            basePopupText: popup_text 
          });
        }
        
        socketRef.current.send(JSON.stringify({
          type: 'query_username',
          userId: properties.userId,
          requestId: requestId
        }));
      }
    };
    
    // Add click handler to fetch username if not cached
    marker.on('click', fetchCreatorInfo);
    return marker;
  };

  // Create a key that includes geometry and relevant usernames from cache
  // This forces re-render when usernames in cache are updated
  const geometryKey = geojson.features.map(f => {
    // Include type, coordinates, and cached username if available
    const baseKey = `${f.geometry.type}_${JSON.stringify(f.geometry.coordinates)}`;
    const cachedUsername = f.properties?.userId ? usernameCache.get(f.properties.userId) : '';
    return `${baseKey}_${cachedUsername || ''}`;
  }).join('_');
  
  return (
    <GeoJSON key={geometryKey} data={geojson} pointToLayer={setIcon} {...rest} />
  )
}